export default {
  placeOrder: `mutation placeOrder($menuEvent: Int!, $meal: Int!, $office: Int) {
          placeOrder(
            menuEvent: $menuEvent,
            meal: $meal,
            office:$office,
          ) {
            id,
            user,
            menuEvent,
            meal,
            menuInfo {
              id,
              office,
              event,
              date,
            },
            mealInfo {
              id,
              name,
              dietInfo {
                id,
                name
              }
            },
          }
        }`,
  deleteOrderById: `mutation deleteOrderById($id: Int!) {
          deleteOrderById(
            id: $id,
          ) {
            destroyed
          }
        }`,
  deleteOrderByMenuEvent: `mutation deleteOrderByMenuEvent($menuEvent: Int!, $meal: Int!) {
          deleteOrderByMenuEvent(
            menuEvent: $menuEvent,
            meal: $meal,
          ) {
            destroyed
          }
        }`,
  deleteOrdersByDay: `mutation deleteOrdersByDay($date: String!, $office: Int!, $startDate: String!, $endDate: String!) {
          deleteOrdersByDay(
            date: $date,
            office: $office,
            startDate: $startDate,
            endDate: $endDate,
          ) {
            id,
            user,
            menuEvent,
            meal,
            menuInfo {
              id,
              office,
              event,
              date,
            },
            mealInfo {
              id,
              name,
              dietInfo {
                name
              }
            },
          }
        }`,
  deleteWeekOrders: `mutation deleteWeekOrders($startDate: String!, $endDate: String!) {
          deleteWeekOrders(
            startDate: $startDate,
            endDate: $endDate,
          ) {
            destroyed
          }
        }`,
  deleteWeekOrdersByEvent: `mutation deleteWeekOrdersByEvent($startDate: String!, $endDate: String!, $event: Int!, $office: Int!) {
    deleteWeekOrdersByEvent(
            startDate: $startDate,
            endDate: $endDate,
            event: $event,
            office: $office,
          ) {
            id,
            user,
            menuEvent,
            meal,
            menuInfo {
              id,
              office,
              event,
              date,
            },
            mealInfo {
              id,
              name,
              dietInfo {
                name
              }
            },
          }
        }`,
  checkUserOrder: `mutation checkUserOrder($orderId: Int!, $served: Boolean!) {
    checkUserOrder(orderId: $orderId, served: $served) {
      id,
      served
    }
  }`,
};



// WEBPACK FOOTER //
// ./src/graphql/mutations/order.js